"use client";

import Slider from "react-slick";
import Image from "next/image";
import { baseSliderSettings } from "@/utils/sliderSettings";
import { NextArrow, PrevArrow } from "./SliderArrows";

type Props = {
  images: string[];
  altPrefix?: string;
};

export default function ImageSlider({
  images = [],
  altPrefix = "Image",
}: Props) {
  const hasImages = images && images.length > 0;

  const settings = {
    ...baseSliderSettings,
    dots: images.length > 1,
    infinite: images.length > 1,
    arrows: images.length > 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Slider {...settings} className="product-slider relative z-10">
      {hasImages ? (
        images.map((img, idx) => (
          <div key={idx} className="outline-none focus:outline-none">
            <div className="h-[480px] flex items-center justify-center relative p-4">
              <Image
                src={img}
                alt={`${altPrefix} ${idx + 1}`}
                fill
                className="object-contain drop-shadow-2xl"
                priority={idx === 0}
                sizes="(max-width: 768px) 100vw, 50vw"
              />
            </div>
          </div>
        ))
      ) : (
        <div className="h-[480px] flex items-center justify-center text-muted/20">
          No images
        </div>
      )}
    </Slider>
  );
}
